<template>
<div class="grid">

  <!-- Image -->
  <div class="col">
    <div class="panel panel-main panel-image">
      <div class="img-outer">
        <div class="img-wrapper">
          <Image :src="imageUrl" v-if="imageUrl" />
          <div v-if="$slots.imageOverlay" class="image-overlay">
            <slot name="imageOverlay" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tags -->
  <div class="col">
    <div class="panel panel-main">
      <div class="panel-head">
        <h4 class="panel-title">
          {{resultTitle}}
        </h4>

        <div class="panel-count" v-if="resultCountTitle">
          <div class="count-title">
            {{resultCountTitle}}
          </div>
          <div class="count">
            {{resultCountMin}}/{{resultCountMax}}
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="panel-body-vert-wrap">
          <slot name="resultBody" />
        </div>
        <template v-if="askFeedback">
          <div class="ask-feedback">
            <div class="ask-feedback-title">
              태그 결과에 만족하시나요?
            </div>
            <!-- {{ imageUrl }} -->
            <div class="ask-feedback-buttons">
              <Button
                color="positive"
                v-on:click="onFeedbackSatisfied"
              >
                완벽해요 :)
              </Button>
              <Button
                color="primary"
                v-on:click="isAskingFeedback = true"
              >
                아쉬워요 :O
              </Button>
            </div>
          </div>
          <teleport to="body">
            <DemoTagFeedbackModal
              v-if="isAskingFeedback"
              v-on:close="isAskingFeedback = false"
              :imageUrl="imageUrl"
              :result="result"
              :tagKey="tagKey"
              ref="feedbackModal"
            />
          </teleport>
        </template>
      </div>
    </div>
  </div>

  <!-- Example -->
  <div class="col" :class="{
    stretch: !extra
  }">
    <div class="panel panel-sub panel-example">
      <div class="panel-head">
        <h4 class="panel-title">
          Example
       </h4>
      </div>
      <div class="panel-body no-pad">
        <div class="example-images-outer"
          ref="rail-outer"
        >
          <div
            class="example-images"
            ref="rail"
            v-dragscroll
            v-on:dragscrollstart="onDragScrollStart"
            v-on:dragscrollend="onDragScrollEnd"
          >
            <!-- v-on:mousedown.prevent="onStart"
            v-on:mouseleave.prevent="onEnd"
            v-on:mouseup.prevent="onEnd"
            v-on:mousemove.prevent="onMove" -->
            <SampleImageItem 
              class="image-item"
              v-for="image, i in sampleImages"
              v-on:click="setSampleImage(image)"
              :key="i"
              :image="$IMG(`assets/samples/${image}`)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Color Dominant -->
  <div class="col" v-if="extra">
    <div class="panel panel-sub">
      <div class="panel-head">
        <h4 class="panel-title">
          {{extraTitle}}
        </h4>
      </div>
      <div class="panel-body">
        <slot name="extraBody"/>
      </div>
    </div>
  </div>

</div>

<div class="btn-row">
  <Button
    size="large"
    color="secondary"
    class="btn-reupload" 
    v-on:click="$emit('reset')"
  >
    이미지 다시 업로드 
    <template v-slot:icon><svgRefresh/></template>
  </Button>
</div>

</template>

<script>
import Button from '@/components/el/Button'
import svgRefresh from '@/svg/svgRefresh'
import SampleImageItem from '@/components/demos/SampleImageItem'
import DemoTagFeedbackModal from './DemoTagFeedbackModal'
import axios from 'axios'

export default {
  props: {
    result: {
      type: [Object, Array],
    },
    tagKey: {
      type: String,
      default: 'base_tags'
    },
    sampleImages: {
      type: Array,
      default: ()=> {
        return [
        ]
      }
    },
    imageUrl: {
      type: [Boolean, String],
      default: false
    },
    askFeedback: {
      type: Boolean,
      default: false
    },
    extra: {
      type: Boolean,
      default: false
    },
    resultTitle: {
      type: String,
      default: "Tags"
    },
    extraTitle: {
      type: String,
      default: "Color Dominant"
    },
    resultCountTitle: {
      type: [String, Boolean],
      default: false
    },
    resultCountMin: {
      type: Number,
      default: 0
    },
    resultCountMax: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isDown: false,
      sampleIndex: false,
      scrollLeft: 0,
      startX: 0,
      mod: 2.0,
      isAskingFeedback: false
    }
  },
  methods: {
    onStart(e) {
      e.stopImmediatePropagation()
      e.stopPropagation()
      e.preventDefault()
      this.isDown = true
      this.scrollLeft =  this.$refs.rail.offsetLeft
      this.startX = e.clientX - this.scrollLeft
    },
    onEnd(e) {
      e.stopImmediatePropagation()
      e.stopPropagation()
      e.preventDefault()
      this.$nextTick(()=> {
        this.isDown = false
      })
      this.scrollLeft = this.$refs.rail.offsetLeft
    },
    onMove(e) {
      if (!this.isDown) return
      const x = e.pageX - this.$refs.rail.offsetLeft
      const amount = (x - this.startX) * this.mod
      this.$refs.rail.scrollLeft = this.scrollLeft - amount
    },
    setSampleImage(image) {
      if (this.isDown) return
      this.$emit('setSampleImage', this.$IMG(`assets/samples/${image}`))
    },
    onDragScrollStart() {
      this.isDown = true
    },
    onDragScrollEnd() {
      setTimeout(()=> {
        this.isDown = false
      }, 250)
    },
    async onFeedbackSatisfied() {
      try {
        await axios.post(`${this.$API_URL}/sticker_tagging/feedback`, {
          image_data: this.imageUrl,
          satisfied: true,
          satisfied_tags: this.result[this.tagKey] || [],
          unsatisfied_tags: []
        }, this.$API_OPTIONS)
        this.$notify(`평가해주셔서 감사합니다.`, {
          id: 'feedbackSatisified'
        })
      } catch (err) {
        console.log(err)
      }
    }
  },
  emits: ['setSampleImage', 'reset'],
  components: {
    svgRefresh,
    Button,
    SampleImageItem,
    DemoTagFeedbackModal
  }
}

</script>

<style lang="scss" scoped>

.col {
  grid-column: span 6;

  @media screen and (max-width: 1104px) {
    width: 100%;
    grid-column: span 12;
  }
}

.col.stretch {
  grid-column: span 12;
}

.panel {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 30px 40px 40px;
  overflow: hidden;
  @media screen and (max-width: 940px) {
    padding: 0;
    background-color: transparent;
  }
}


.panel-main {
  width: 100%;
  height: 588px;
  @media screen and (max-width: 1104px) {
    height: auto;
  }
}

.panel-image {
  padding: 0;
  @media screen and (max-width: 1104px) {
    height: 240px;
  }
  @media screen and (max-width: 768px) {
    height: 160px;
  }
}

.panel-sub {
  height: 270px;
  padding: 30px 40px 30px;
  @media screen and (max-width: 940px) {
    padding: 0;
    height: auto;
    background-color: transparent;
  }
}

.panel-example {
  padding-bottom: 0;
}

.panel-head {
  display: flex;
  justify-content: space-between;
  padding: 0 0 14px;
  border-bottom: 1px solid var(--gray-300);
}

.panel-example .panel-head {
  padding: 0 0 24px;
  border: 0;
  @media screen and (max-width: 940px) {
    padding: 0 0 14px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--gray-300);

  }
}

.panel-count {
  background-color: var(--gray-100);
  padding: 0 18px;
  height: 37px;
  border-radius: 37px;
  display: flex;
  align-items: center;
}

.panel-count .count-title {
  font-size: var(--typ-body3);
  color: var(--gray-900);
  font-weight: 700;
}
.panel-count .count {
  font-size: var(--typ-body2);
  color: var(--info-500);
  font-weight: 700;
  margin-left: 16px;
}

h4.panel-title {
  font-size: var(--typ-h4);
  color: var(--gray-700);
  margin: 0;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-h7);
  }
}

.panel-body {
  flex: 1;
  overflow: hidden;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  &.no-pad {
    padding: 0;
  }
}

.panel-body-vert-wrap {
  flex: 1;
  overflow: auto;
}

.img-outer {
  background-color: var(--gray-300);
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
}

.example-images {
  display: flex;
  overflow: hidden;
}

.img-wrapper {
  position: relative;
  margin: auto;
}

.img-wrapper img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  @media screen and (max-width: 1104px) {
    max-height: 240px;
  }
  @media screen and (max-width: 768px) {
    max-height: 160px;
  }
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background: rgba(255, 0, 0, 0.25);
}

.btn-row {
  margin-top: 38px;
  text-align: center;
}

.btn-reupload {
  // display: inline-flex;
  // align-items: center;
  padding: 0 97px;
  // height: 56px;
  // background-color: var(--gray-900);
  // color: white;
  // font-weight: 700;
  // font-size: var(--typ-body2);
  // border-radius: 8px;
  // outline: 0;

  @media screen and (max-width: 940px) {
    font-size: var(--typ-body3);
  }
  @media screen and (max-width: 540px) {
    width: 100%;
    padding: 0 16px;
  }

  // svg {
  //   margin-left: 10px;
  //   width: 24px;
  //   height: 24px;
  // }
}


.ask-feedback {
  padding-top: 16px;
  border-top: 1px solid var(--gray-300);
  @media screen and (max-width: 1104px) {
    border-top-color: transparent;
  }
}
.ask-feedback-title {
  color: var(--gray-900);
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
}

.ask-feedback-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 8px 0 0;
}

.ask-feedback-buttons button {
  width: 120px;
}

</style>

